import React, { useEffect, useState, memo } from "react";

const InputField = memo(
  function InputField({ label, value, onChange, options, hasError, required }) {
    const [isSelected, setIsSelected] = useState(false);
    const id = label.toLowerCase().replace(/[^a-z0-9]+/g, '-');

    useEffect(() => {
      setIsSelected(!!value);
    }, [value]);

    return (
      <div className={`mb-6 w-full group relative ${hasError ? 'animate-shake' : ''}`}>
        <label
          className={`form-label uppercase tracking-wide mb-2 transition-colors duration-200 ${
            isSelected ? 'text-primary' : 'text-secondary'
          } ${hasError ? 'text-red-400' : ''}`}
          htmlFor={id}
        >
          {label}
          {required && <span className="text-red-400 text-sm ml-1">*</span>}
        </label>
        <div className="relative overflow-visible z-10">
          <select
            id={id}
            value={value}
            onChange={onChange}
            className={`form-select w-full appearance-none cursor-pointer ${
              hasError ? 'animate-shake shadow-[0_0_20px_-3px] shadow-red-500/60' : 
              isSelected ? 'shadow-[0_0_15px_-3px] shadow-green-500/40' : 
              'shadow-[0_0_0_0] shadow-transparent'
            } ${
              isSelected ? '!border-green-500' : ''
            } transition-all duration-300 ${
              hasError ? '' : 
              'hover:shadow-[0_0_25px_-5px] ' + 
              (isSelected ? 'hover:shadow-green-500/30' : 'hover:shadow-primary/20')
            }`}
            style={{ WebkitAppearance: 'none', MozAppearance: 'none' }}
          >
            <option value="">Select</option>
            {options.map((option) => (
              <option 
                key={option} 
                value={option}
                className="aria-selected:bg-primary/10 aria-selected:text-primary"
              >
                {option}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
            <svg className="h-4 w-4 text-secondary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          {isSelected && (
            <div className={`pointer-events-none absolute right-8 top-1/2 -translate-y-1/2 w-2 h-2 ${
              hasError ? 'bg-red-500 animate-ping' : 'bg-green-500 animate-pulse-glow'
            } rounded-full`} />
          )}
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.value === nextProps.value && 
           prevProps.hasError === nextProps.hasError &&
           prevProps.options === nextProps.options &&
           prevProps.required === nextProps.required;
  }
);

export default InputField;
